module.exports = __webpack_public_path__ + "img/1.a54e127d.png";